import { render } from "./VariavelComponent.vue?vue&type=template&id=1947c02a&ts=true"
import script from "./VariavelComponent.vue?vue&type=script&lang=ts"
export * from "./VariavelComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__